import React, { useReducer, useEffect, useContext} from "react";
import peligroContext from "./peligroContex";
import { getAllPeligro, addPeligro, updatePeligro, deletePeligro } from "../../api/peligro";
import peligroReducer from "./peligroReducer";
import authContext from "../authentication/authContex";

//Types
import {
    ACTUALIZAR_LIST_PELIGRO,
  } from "./peligroActions";
import { SocketContext } from "../socket/socket";

const PeligroState = props =>{

    const initialState = {
        peligroIDLista: []
     };

    const [state, dispatch] = useReducer(peligroReducer, initialState);
    const server = useContext(SocketContext);
    const auContext = useContext(authContext);
    const {usuario, verificarTenant} = auContext;

    const actualizarPeligroLista = async () => {
        try{
            const resp = await getAllPeligro();
            const peligro = resp.data.data;
            dispatch({
                type: ACTUALIZAR_LIST_PELIGRO,
                payload: peligro
            });
            return peligro;
        }catch(err){
            console.log(err)
        }
    };

    const agregarPeligro = async (dato) => {
        try{
            const resp = await addPeligro(dato);
            const peligro = resp.data.data;
            return peligro;
        }catch(err){
            console.log(err);
            return null;
        }
    };

    const modificarPeligro = async (dato) => {
        try{
            const resp = await updatePeligro(dato);
            const peligro = resp.data.data;
            return peligro;
        }catch(err){
            console.log(err)
            return null;
        }
    }

    const eliminarPeligro = async (id, tDocID) => {
        try{
            const resp = await deletePeligro(id, tDocID);
            return resp;
        }catch(err){
            console.log(err)
        }
    }

    useEffect(() => {
        if(usuario != null) actualizarPeligroLista();
    },[usuario])

    useEffect(()=>{
            if(server){
                server.on('peligrosEdited', ({tenantId}) =>{
                    console.log("Recibo el evento del Real Time Server peligrosEdited");
                    const verification = verificarTenant(tenantId)
                    if(verification){
                        actualizarPeligroLista();
                    }
                })
                return () => {
                    server.off('peligrosEdited');
                }
            }
        },[server])

    return(
        <peligroContext.Provider
            value={{
                peligroIDLista: state.peligroIDLista,
                actualizarPeligroLista,
                agregarPeligro,
                modificarPeligro,
                eliminarPeligro
            }}
        >
            {props.children}
        </peligroContext.Provider>
    )

}

export default PeligroState;
